import { render, staticRenderFns } from "./NewTreatmentOption.vue?vue&type=template&id=3e4780d0&scoped=true"
import script from "./NewTreatmentOption.vue?vue&type=script&lang=js"
export * from "./NewTreatmentOption.vue?vue&type=script&lang=js"
import style0 from "./NewTreatmentOption.vue?vue&type=style&index=0&id=3e4780d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4780d0",
  null
  
)

export default component.exports